module.exports = __webpack_public_path__ + "img/nissan-versa.e04de963.jpg";